module.exports = __webpack_public_path__ + "static/media/intelli.e472b047.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/intelli.png
// module id = 795
// module chunks = 0